@use '../../scss/abstracts/mixins' as *;
@use '../../scss/abstracts/variables' as *;

.section {
  background: #efe7d7;
  padding: 4.5rem 0 5rem;

  @media screen and (max-width: $tablet-portrait) {
    padding: 6rem 0;
  }
}

.wrap {
  @include content-size;
  padding: 0 10.5rem;

  @media (max-width: $tablet-landscape) {
    padding: 0 6rem;
  }

  @media (max-width: $tablet-portrait) {
    padding: 0 4.2rem;
  }

  @media (max-width: $phone) {
    padding: 0 1.8rem;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 2rem;
  margin-bottom: 5.2rem;

  @media (max-width: $tablet-landscape) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.eyebrow {
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: #bf8a2e;
  margin-bottom: 0.8rem;
}

.heading {
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  font-size: 3.2rem;
  color: #2b2820;
  margin: 1.4rem 0 1.4rem;

  em,
  i {
    font-style: italic;
    color: #bf8a2e;
  }
}

.accent {
  font-family: 'Playfair Display', serif;
  font-style: italic;
  color: #bf8a2e;
}

.lead {
  font-family: 'Playfair Display', serif;
  font-style: italic;
  font-size: 1.5rem;
  line-height: 1.7;
  color: #5b5544;
  max-width: 50rem;
}

.footer {
  text-align: center;
  margin-top: 4.4rem;
}

.viewAll {
  display: inline-block;
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #241a08;
  background: #bf8a2e;
  padding: 1.2rem 2.8rem;
  text-decoration: none;
  transition: background-color 0.2s ease;

  &:hover {
    background: #a8742a;
  }
}

.cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 3rem;

  @media (max-width: $tablet-landscape) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 2.4rem;
  }

  @media (max-width: $tablet-portrait) {
    grid-template-columns: 1fr;
  }
}

.card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(31, 24, 12, 0.06);
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease;
  color: inherit;
  text-decoration: none;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 22px 46px rgba(31, 24, 12, 0.14);
    color: inherit;
    text-decoration: none;
  }
}

.media {
  position: relative;
  height: 23rem;
  background: linear-gradient(135deg, #6b5638, #3c2c1a);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.badge {
  position: absolute;
  top: 1.4rem;
  left: 1.4rem;
  font-family: 'Inter', sans-serif;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #c9a44d;
  background: rgba(33, 27, 18, 0.85);
  padding: 0.6rem 1.2rem;
  border-radius: 0;
}

.featured {
  position: absolute;
  top: 1.4rem;
  right: 1.4rem;
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #241a08;
  background: #bf8a2e;
  padding: 0.6rem 1.1rem;
  border-radius: 0;
}

.body {
  padding: 2.4rem 2.4rem 0;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.region {
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #bf8a2e;
  font-weight: 600;
}

.title {
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  font-size: 1.8rem;
  color: #2b2820;
  margin: 0.8rem 0 1rem;
  line-height: 1.2;
}

.views {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  color: #635f54;
  background: #f4eee1;
  padding: 0.4rem 0.8rem;
  border-radius: 4px;
  line-height: 1;
  flex-shrink: 0;

  .viewIcon {
    width: 1.15rem;
    height: 1.15rem;
    opacity: 0.65;
  }
}

.description {
  font-family: 'Inter', sans-serif;
  font-size: 1.25rem;
  line-height: 1.6;
  color: #4a4636;
  margin-bottom: 0.7rem;
  flex: 1;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem 1.6rem;
  margin-bottom: 0.7rem;
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  color: #6d6655;

  b {
    color: #2b2820;
  }
}

.foot {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #ddd4c2;
  padding: 1rem 1.4rem;
  flex-wrap: nowrap;
  gap: 0.6rem;

  @media (max-width: 480px) {
    flex-wrap: wrap;
    gap: 0.8rem;
  }
}

.price {
  font-family: 'Inter', sans-serif;
  white-space: nowrap;
  flex-shrink: 0;
}

.amt {
  font-family: 'Playfair Display', serif;
  font-weight: 700;
  font-size: 1.35rem;
  color: #2b2820;
}

.per {
  font-size: 0.82rem;
  color: #6d6655;
}

.actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;

  @media (max-width: 480px) {
    width: 100%;
    justify-content: space-between;
  }
}

.cardLink {
  display: flex;
  flex-direction: column;
  flex: 1;
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
    text-decoration: none;
  }
}

.quotesBtn,
.bookDirectBtn {
  font-family: 'Inter', sans-serif;
  font-size: 0.76rem;
  font-weight: 600;
  letter-spacing: 0.03rem;
  text-transform: uppercase;
  padding: 0.65rem 0.75rem;
  border-radius: 0;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.quotesBtn {
  background: #bf8a2e;
  color: #241a08;

  &:hover {
    background: #a8742a;
    color: #241a08;
  }
}

.bookDirectBtn {
  background: #3a6b4a;
  color: #fff;

  &:hover {
    background: #2f5a3d;
    color: #fff;
  }
}

.bookDirectBtnDisabled {
  background: #e3ddd0;
  color: #a39a87;
  cursor: not-allowed;
  pointer-events: none;
}
